import { $api } from "../generated/client";

export function useLoggedViewer() {
  return $api.useSuspenseQuery("get", "/users/me");
}
